module.exports = __webpack_public_path__ + "img/GHS05.40cf2cbd.webp";